import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 73732965-3E0C-4746-8D18-785E318F005D
 * name view-column-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-column-outline.svg
 * tags
 * - View 
 */
export const ViewColumnOutlineIcon = createSvgIcon(<><path d="M4 5V18H21V5H4M14 7V16H11V7H14M6 7H9V16H6V7M19 16H16V7H19V16Z" /></>, 'ViewColumnOutlineIcon');
export default ViewColumnOutlineIcon